import OlympiadDetails from './OlympiadDetails';

export default OlympiadDetails;
